import type { AutomaticStayLine } from "./reservationBilling";

export interface PersistedStayComandaLine {
  itemId: string | null;
  itemName: string;
  quantity: number;
  unitPrice: number;
  billingRole: "stay" | "extra";
  stayDate: string | null;
}

export function expandAutomaticStayCharges(lines: AutomaticStayLine[]): PersistedStayComandaLine[] {
  return lines
    .filter((line) => line.status === "charged" && (line.stayDates?.length ?? 0) > 0)
    .flatMap((line) => (line.stayDates ?? []).map((stayDate) => ({
      itemId: line.itemId,
      itemName: line.itemName,
      quantity: 1,
      unitPrice: line.unitPrice,
      billingRole: line.billingRole,
      stayDate,
    })));
}
